import modalsComponent from './modals';

export default angular.module('doxy.common.components.modals', [
  modalsComponent,
]).name;
